import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { UserInfo, UserRole, userRoleMap } from '../types/user';
import { userService } from '../services';
import { useAuthStore } from './auth';
import { utils } from '../utils';
import defaultAvatar from '../assets/imgs/isaac_avatar.png'

export const useUserStore = defineStore('user', () => {
    const userInfo = ref<UserInfo | null>(null)
    const auth = useAuthStore()
    const username = computed(() => {
        const accessTokenBody = utils.decodeJwt(auth.accessToken)
        return accessTokenBody?.name
    })
    const userRole = computed(() => {
        const accessTokenBody = utils.decodeJwt(auth.accessToken)
        if (accessTokenBody?.role === 'AC/AO') {
            accessTokenBody.role = UserRole.teacher
        }
        return accessTokenBody?.role
    })
    const userRoleName = computed(() => userRole.value ? userRoleMap[userRole.value] : '')

    async function getUserInfo() {
        let userInfoData = null
        if (userRole.value === UserRole.student) {
            userInfoData = await userService.getStudentInfo()
        }
        if (userRole.value === UserRole.teacher) {
            userInfoData = await userService.getTeacherInfo()
        }
        //default avatar for no avatar user
        if (userInfoData && !userInfoData.avatar) {
            userInfoData.avatar = defaultAvatar;
        }
        userInfo.value = userInfoData;
    }

    function clearUserInfo() {
        userInfo.value = null;
    }

    return { userInfo, userRole, userRoleName, username, getUserInfo, clearUserInfo }
});
